import React from 'react';

import { List } from 'antd';

import styled from 'styled-components';

import BookItem from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/BookItem';

const Wrapper = styled.div`
    .books-in-package-list {
        ${(props) =>
            props.$scrollable &&
            `
            max-height: 30vh;
            overflow-y: auto;
            overscroll-behavior: contain;
        `}

        /* Sempre due colonne. Non uso la prop grid di List: manterrebbe il suo wrapping
           in Row/Col, qui basta impaginare gli li che List già rende. */
        .ant-list-items {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            column-gap: 0.5rem;
        }

        /* In colonna stretta due colonne non ci stanno */
        @media only screen and (max-width: 720px) {
            .ant-list-items {
                grid-template-columns: 1fr;
            }
        }

        scrollbar-width: thin;
        scrollbar-color: ${(props) => props.theme.BorderColor} transparent;

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: ${(props) => props.theme.BorderColor};
            border-radius: 3px;
        }

        &:hover::-webkit-scrollbar-thumb {
            background-color: ${(props) => props.theme.TextColorMuted};
        }
    }
`;

/**
 * Separa i book della modella già nel package da quelli ancora da aggiungere.
 * I primi arrivano dalla lista completa, così restano visibili anche quando i filtri
 * li escluderebbero: sono un elenco di controllo, non qualcosa da cercare.
 */
export function splitBooksByPackage(allBooks, filteredBooks, addedPlaylistIDs) {
    const added = new Set(addedPlaylistIDs || []);
    return {
        booksInPackage: (allBooks || []).filter((book) => added.has(book.ID)),
        booksToAdd: (filteredBooks || []).filter((book) => !added.has(book.ID)),
    };
}

/**
 * Elenco dei book già nel package: sempre righe compatte su due colonne, anche quando
 * sono pochi. È un elenco di controllo e deve costare poco spazio, non renderli al meglio.
 * La testata la porta il blocco del pannello.
 */
const BooksInPackageList = ({ books, scrollable = false }) => {
    return (
        <Wrapper $scrollable={scrollable}>
            <div className="books-in-package-list">
                <List
                    itemLayout="horizontal"
                    dataSource={books}
                    renderItem={(book) => <BookItem book={book} compact />}
                />
            </div>
        </Wrapper>
    );
};

export default BooksInPackageList;
